module.exports = __webpack_public_path__ + "static/media/summer-promo.4ddaec44.jpg";